var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 960 960",
    style: {
      enableBackground: "new 0 0 960 960"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#C1272D;}\n\t.st2{fill:#991D26;}\n\t.st3{fill:#CCCCCC;}\n\t.st4{fill:#E6E6E6;}\n\t.st5{fill:#F7931E;}\n\t.st6{fill:#F2F2F2;}\n\t.st7{fill:none;stroke:#999999;stroke-width:17.9763;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#333333;stroke-width:8.9882;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#C1272D;stroke-width:5.9921;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st10{fill:#245F7F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M601.2,699.8H205c-30.7,0-55.6-24.9-55.6-55.6V248c0-30.7,24.9-55.6,55.6-55.6h396.2 c30.7,0,55.6,24.9,55.6,55.6v396.2C656.8,674.9,631.9,699.8,601.2,699.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M601.2,192.4H205c-30.7,0-55.6,24.9-55.6,55.6v88.5h507.4V248C656.8,217.3,631.9,192.4,601.2,192.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 253.3,
    cy: 264.5,
    r: 36.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 551.6,
    cy: 264.5,
    r: 36.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M253.3,275.7L253.3,275.7c-11.8,0-21.3-9.6-21.3-21.3v-85.8c0-11.8,9.6-21.3,21.3-21.3l0,0 c11.8,0,21.3,9.6,21.3,21.3v85.8C274.6,266.2,265.1,275.7,253.3,275.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M551.6,275.7L551.6,275.7c-11.8,0-21.3-9.6-21.3-21.3v-85.8c0-11.8,9.6-21.3,21.3-21.3l0,0 c11.8,0,21.3,9.6,21.3,21.3v85.8C573,266.2,563.4,275.7,551.6,275.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.7,
    y: 370.9,
    className: "st4",
    width: 75.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 370.9,
    className: "st4",
    width: 75.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.2,
    y: 370.9,
    className: "st4",
    width: 75.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.5,
    y: 370.9,
    className: "st4",
    width: 75.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.7,
    y: 465,
    className: "st4",
    width: 75.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 465,
    className: "st1",
    width: 75.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.2,
    y: 465,
    className: "st4",
    width: 75.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.5,
    y: 465,
    className: "st4",
    width: 75.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.7,
    y: 559.1,
    className: "st4",
    width: 75.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 559.1,
    className: "st4",
    width: 75.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.2,
    y: 559.1,
    className: "st4",
    width: 75.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.5,
    y: 559.1,
    className: "st4",
    width: 75.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 621.9,
    cy: 624,
    r: 188.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 621.9,
    cy: 624,
    r: 148
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M486.6,636.8c0-81.7,66.3-148,148-148c37.6,0,72,14.1,98.1,37.2c-27.1-30.6-66.7-49.9-110.8-49.9 c-81.7,0-148,66.3-148,148c0,44.1,19.3,83.7,49.9,110.8C500.7,708.7,486.6,674.4,486.6,636.8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "621.9,530.4 621.9,624 559,624  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 621.9,
    y1: 508.3,
    x2: 621.9,
    y2: 497.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 621.9,
    y1: 756.3,
    x2: 621.9,
    y2: 745.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 740.3,
    y1: 626.7,
    x2: 751.5,
    y2: 626.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 492.3,
    y1: 626.7,
    x2: 503.5,
    y2: 626.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 705.6,
    y1: 710.4,
    x2: 713.5,
    y2: 718.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 530.3,
    y1: 535.1,
    x2: 538.2,
    y2: 543
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 538.2,
    y1: 710.4,
    x2: 530.3,
    y2: 718.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 713.5,
    y1: 535.1,
    x2: 705.6,
    y2: 543
  })), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 604.4,
    y1: 606.3,
    x2: 684.5,
    y2: 687.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 621.9,
    cy: 624,
    r: 16.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduler);
export default __webpack_public_path__ + "static/media/scheduler.157c346f8f67dc7124f6588c10d69d5f.svg";
export { ForwardRef as ReactComponent };